module.exports = __webpack_public_path__ + "static/images/status-invalid.3DjaBU0.svg";